import React from "react";
import css from "./index.module.scss";
import { useInView, animated } from "@react-spring/web";
import { useTranslation } from "react-i18next";
import i18n from "i18next";

const bList = [
  "$singlee_yt14",
  "$singlee_yt15",
  "$singlee_yt16",
  "$singlee_yt17",
  "$singlee_yt18",
  "$singlee_yt19",
  "$singlee_yt20",
  "$singlee_yt21",
  "$singlee_yt22",
  "$singlee_yt24",
  "$singlee_yt25",
];

function Index() {
  const { t } = useTranslation();

  const [firstRef, firstRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
    }),
    { threshold: 0.1, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );
  const [secondRef, secondRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateY(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0%)",
      },
      config: { duration: 300 },
    }),
    { threshold: 0.3, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );
  const [thirdRef, thirdRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateY(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0%)",
      },
    }),
    { threshold: 0.4, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );

  return (
    <div className={css.cloudcontain}>
      <div className={css.maintitle}>{t("银医通")}</div>

      <div className={css.first} ref={firstRef}>
        <animated.div className={css.inner} style={firstRefStyle}>
          <div className={`${css.subtitle}`}>{t("行业痛点")}</div>
          <div className={css.boxzone}>
            <div className={css.box}>
              <div className={`${css.pic}`}>
                <div className={css.t1}></div>
              </div>
              <div className={css.desc}>{t("$singlee_yt1")}</div>
            </div>
            <div className={css.box}>
              <div className={`${css.pic}`}>
                <div className={css.t2}></div>
              </div>
              <div className={css.desc}>{t("$singlee_yt2")}</div>
            </div>
            <div className={css.box}>
              <div className={`${css.pic}`}>
                <div className={css.t3}></div>
              </div>
              <div className={css.desc}>{t("$singlee_yt3")}</div>
            </div>
            <div className={css.box}>
              <div className={`${css.pic}`}>
                <div className={css.t4}></div>
              </div>
              <div className={css.desc}>{t("$singlee_yt4")}</div>
            </div>
          </div>
        </animated.div>
      </div>

      <div className={css.second} ref={secondRef}>
        <animated.div className={css.inner} style={secondRefStyle}>
          <div className={`${css.subtitle}`}>{t("基础功能")}</div>
          <div className={css.box}>
            <div className={css.left}>
              <div className={css.item}>
                <div className={css.top}>
                  <div className={css.end}>
                    <div className={`${css.icon} ${css.m1}`}></div>
                  </div>
                  <div className={css.title}>{t("$singlee_yt5")}</div>
                </div>
                <div className={css.desc}>{t("$singlee_yt6")}</div>
              </div>
              <div className={css.item}>
                <div className={css.top}>
                  <div className={css.end}>
                    <div className={`${css.icon} ${css.m2}`}></div>
                  </div>
                  <div className={css.title}>{t("$singlee_yt7")}</div>
                </div>
                <div className={css.desc}>{t("$singlee_yt8")}</div>
              </div>
            </div>
            <div className={css.bg}></div>
            <div className={css.right}>
              <div className={css.item}>
                <div className={css.top}>
                  <div className={`${css.icon} ${css.m3}`}></div>
                  <div className={css.title}>{t("$singlee_yt9")}</div>
                </div>
                <div className={css.desc}>{t("$singlee_yt10")}</div>
              </div>
              <div className={css.item}>
                <div className={css.top}>
                  <div className={`${css.icon} ${css.m4}`}></div>
                  <div className={css.title}>{t("$singlee_yt11")}</div>
                </div>
              </div>
              <div className={css.item}>
                <div className={css.top}>
                  <div className={`${css.icon} ${css.m5}`}></div>
                  <div className={css.title}>{t("$singlee_yt12")}</div>
                </div>
                <div className={css.desc}>{t("$singlee_yt13")}</div>
              </div>
            </div>
          </div>
        </animated.div>
      </div>

      <div className={css.third} ref={thirdRef}>
        <div className={css.inner}>
          <div className={css.subtitle}>{t("部分合作案例")}</div>
          <animated.div
            className={`${css.box} ${
              i18n.language === "zh" ? "" : css.gridrp1
            }`}
            style={thirdRefStyle}
          >
            {bList.map((item, index) => {
              return (
                <div className={css.item} key={index}>
                  <div className={css.name}>{t(item)}</div>
                </div>
              );
            })}
          </animated.div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(Index);
